import { DSNCOpinion } from 'shared-definitions/types'
import { ApiComponentOpinions } from 'data-source/types.wp'
import { imageMapper } from 'data-source/mappers/imageMapper'
import { PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'

export function ncOpinions(input: ApiComponentOpinions, opts: PLinkMapperOpts): DSNCOpinion {
  return {
    resource: 'nc-opinion',
    text: input.text,
    hint:
      input.disclaimer ??
      'You are reading an Opinion post. This post may not represent the views of the entire Android Authority team.',
    pLink: opts.postLinkBuilder(input.slug),
    authorName: input.author,
    image: imageMapper(input.image, opts),
  }
}
